import { Controller } from "@hotwired/stimulus";

/**
 * Contrôleur pour pré-sélectionner une variation basée sur l'URL
 * Utilisé quand on arrive depuis l'agenda avec ?variation_id=123
 */
export default class extends Controller {
  connect() {
    this.preselectVariationFromURL();
  }

  preselectVariationFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variationId = urlParams.get('variation_id');

    if (!variationId) {
      return;
    }

    // Attendre que le formulaire de variations soit chargé
    setTimeout(() => {
      this.selectVariation(variationId);
    }, 100);
  }

  selectVariation(variationId) {
    // Trouver le formulaire de variations
    const form = document.querySelector('.variations_form');
    if (!form) {
      return;
    }

    // Récupérer les données de variations
    const variationsData = form.getAttribute('data-product_variations');
    if (!variationsData) {
      return;
    }

    const variations = JSON.parse(variationsData);
    const targetVariation = variations.find(v => v.variation_id == variationId);

    if (!targetVariation) {
      return;
    }

    // Sélectionner les attributs correspondants
    Object.entries(targetVariation.attributes).forEach(([attrName, attrValue]) => {
      const select = form.querySelector(`select[name="${attrName}"]`);
      if (select && attrValue) {
        select.value = attrValue;
        // Déclencher l'événement change pour mettre à jour le formulaire
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}
